/**
 * Compact talk-time label for the legend. `formatClock` / `formatDurationClock`
 * render `mm:ss`, which is the wrong shape next to a percentage. Under a
 * minute we keep the seconds, so a 32s turn is not rounded down to "0m".
 */
export function formatTalkShare(seconds: number): string {
  if (!Number.isFinite(seconds) || seconds <= 0) return "0s"
  const whole = Math.round(seconds)
  if (whole < 60) return `${whole}s`
  return `${Math.round(whole / 60)}m`
}
